var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInventoryValue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#F9ECD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 11.3333C3.33398 8.99557 3.33398 7.82669 3.93929 7.03995C4.0501 6.89592 4.17391 6.76386 4.30894 6.64566C5.0465 6 6.14233 6 8.33398 6H11.6673C13.859 6 14.9548 6 15.6924 6.64566C15.8274 6.76386 15.9512 6.89592 16.062 7.03995C16.6673 7.82669 16.6673 8.99557 16.6673 11.3333C16.6673 13.6711 16.6673 14.84 16.062 15.6267C15.9512 15.7707 15.8274 15.9028 15.6924 16.021C14.9548 16.6667 13.859 16.6667 11.6673 16.6667H8.33398C6.14233 16.6667 5.0465 16.6667 4.30894 16.021C4.17391 15.9028 4.0501 15.7707 3.93929 15.6267C3.33398 14.84 3.33398 13.6711 3.33398 11.3333Z",
    stroke: "#AC6600",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6673 6.00004C12.6673 4.74296 12.6673 4.11442 12.2768 3.7239C11.8863 3.33337 11.2577 3.33337 10.0007 3.33337C8.74357 3.33337 8.11503 3.33337 7.72451 3.7239C7.33398 4.11442 7.33398 4.74296 7.33398 6.00004",
    stroke: "#AC6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 9.33329C9.26492 9.33329 8.66797 9.78101 8.66797 10.3333C8.66797 10.8856 9.26492 11.3333 10.0013 11.3333C10.7377 11.3333 11.3346 11.781 11.3346 12.3333C11.3346 12.8856 10.7377 13.3333 10.0013 13.3333M10.0013 9.33329C10.5818 9.33329 11.0757 9.61156 11.2588 9.99996M10.0013 9.33329V8.66663M10.0013 13.3333C9.42076 13.3333 8.92688 13.055 8.74384 12.6666M10.0013 13.3333V14",
    stroke: "#AC6600",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10H3.33333",
    stroke: "#AC6600",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.668 10L14.0013 10",
    stroke: "#AC6600",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInventoryValue);
export default __webpack_public_path__ + "static/media/icon-inventory-value.563eda78bf258a45b865911b9e381431.svg";
export { ForwardRef as ReactComponent };